module.exports = __webpack_public_path__ + "img/0-28.d11256df.jpg";